// @flow
'use strict';

import CofinsStPerc from './cofins_st_perc';
import CofinsStQtde from './cofins_st_qtde';

export default {
  CofinsStPerc, CofinsStQtde,
};
